import {
  CART_ADD_ITEM,
  CART_CLEAR,
  CART_REMOVE_ITEM,
  CART_SAVE_PAYMENT_METHOD,
  FAVOURITES_ADD_ITEM,
  FAVOURITES_REMOVE_ITEM,
} from "../actions/constants/cart.js";
import { getCartItemKey, normalizePatternSize, resolveCartSelectedSize } from "../utils/patternSize";

export const cartReducer = (state = [], action: any) => {
  const { type, payload } = action;

  switch (type) {
    case CART_ADD_ITEM: {
      const item = payload;
      const itemKey = getCartItemKey(item);
      const existItem: any = state.find(
        (x: any) => getCartItemKey(x) === itemKey
      );
      if (existItem) {
        return state.map((x: any) =>
          getCartItemKey(x) === itemKey ? item : x
        );
      } else {
        return [...state, item];
      }
    }
    case CART_REMOVE_ITEM: {
      if (typeof payload === "string") {
        return state.filter((a: any) => a.id !== payload);
      }

      const targetId = payload?.id;
      const targetSize =
        typeof payload?.selectedSize === "string" && payload.selectedSize.trim()
          ? normalizePatternSize(payload.selectedSize)
          : null;

      return state.filter((item: any) => {
        if (item.id !== targetId) {
          return true;
        }

        const itemSize = resolveCartSelectedSize(item);
        if (targetSize) {
          return itemSize !== targetSize;
        }

        return !!itemSize;
      });
    }
    case  CART_CLEAR: {
      return [];
    }
    default:
      return state;
  }
};
export const favouritesReducer = (state = [], action: any) => {
  const { type, payload } = action;
  switch (type) {
    case FAVOURITES_ADD_ITEM: {
      const item = payload;
      const existItem: any = state.find((x: any) => x.id === item.id);
      if (existItem) {
        return state.map((x: any) => (x.id === item.id ? item : x));
      } else {
        return [...state, item];
      }
    }
    case FAVOURITES_REMOVE_ITEM:
      return state.filter((a: any) => a.id !== payload);
    default:
      return state;
  }
};

export const paymentReducer = (state = {}, action: any) => {
  const { type, payload } = action;

  switch (type) {
    case CART_SAVE_PAYMENT_METHOD:
      return { ...state, payment: payload };
    default:
      return state;
  }
};
